<!--公司基本信息-->
<template>
  <div class="module">
    <h5 class="module-title">公司基本信息</h5>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="公司名称：" label-width="130px">
            {{ defaultForm.companyName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司注册地：">
            {{ defaultForm?.province }}{{ defaultForm?.city
            }}{{ defaultForm?.district }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="注册地址：" prop="name" label-width="130px">
            {{ defaultForm.regCity }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="营业执照号：" prop="region">
            {{
              ruleForm.settleAccountAttachTempList[getIndexByFileType('MRC')]
                .certificateNo
            }}
            <el-button
              type="text"
              size="small"
              @click="previewFile('MRC', ruleForm?.settleAccountAttachTempList)"
              >预览
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="营业执照有效期："
            :prop="`settleAccountAttachTempList[${getIndexByFileType(
              'MRC'
            )}].certificateLongValid`"
            :rules="rules.certificateLongValid"
            label-width="130px"
          >
            <el-radio-group
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('MRC')]
                  .certificateLongValid
              "
              @change="radioChange('MRC')"
            >
              <el-radio :label="true">长期有效</el-radio>
              <el-radio :label="false">有效期至</el-radio>
            </el-radio-group>
            <el-date-picker
              v-show="mrcDateShow"
              v-model="
                ruleForm.settleAccountAttachTempList[getIndexByFileType('MRC')]
                  .certificateEndTime
              "
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import { paymentAccountOpeningMixins, commonMethodsMixins } from '../constant';
import ViewerImage from '../components/viewerImage';

export default {
  name: 'CompanyBaseInfo',
  components: {
    ViewerImage,
  },
  mixins: [paymentAccountOpeningMixins, commonMethodsMixins],
  data() {
    return {
      ruleForm: {
        settleAccountAttachTempList: [
          {
            attachName: '',
            attachPath: '',
            attachType: 'MRC',
            certificateBeginTime: '',
            certificateEndTime: '',
            certificateLongValid: true,
            certificateNo: '',
          },
        ],
      },
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(sourceData, defaultForm) {
      this.defaultForm = Object.assign(this.defaultForm, defaultForm);
      if (!sourceData?.settleAccountAttachTempList) {
        return;
      }
      this.ruleForm.settleAccountAttachTempList.forEach((attachItem, index) => {
        const tempObj = sourceData.settleAccountAttachTempList.find(
          (tempItem) => tempItem.attachType === attachItem.attachType
        );
        if (tempObj) {
          Object.keys(attachItem).forEach((key) => {
            attachItem[key] = tempObj[key] ?? attachItem[key];
          });
          attachItem.certificateLongValid = !!attachItem.certificateLongValid;
          this.$set(
            this.ruleForm.settleAccountAttachTempList,
            index,
            attachItem
          );
        }
      });
      this.radioChange('MRC');
      console.log(
        this.ruleForm.settleAccountAttachTempList,
        'companyBaseInfo init'
      );
    },
    // 预览
    previewFile(type, list) {
      const fileObj = this.getAttachmentInfo(type, list);
      if (fileObj.attachPath) {
        this.handlePreview(fileObj.attachPath);
      } else {
        this.$message.info('暂无可预览文件');
      }
    },
    // 获取附件信息
    getAttachmentInfo(type, list) {
      const sourceData = list ?? this.ruleForm?.settleAccountAttachTempList;
      return sourceData?.find((item) => item.attachType === type);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
